import { CampaignFilterIds } from 'pages/Campaigns/constants/filters';
import { getCampaignStatusLabel } from './getCampaignStatusLabel';
import { CampaignStatus } from 'generated-graphql/types';

export const getCampaignFilterLabel = (
  filterId: CampaignFilterIds,
  value: string | boolean
) => {
  if (filterId === CampaignFilterIds.status) {
    return getCampaignStatusLabel(value as CampaignStatus);
  }

  if (filterId === CampaignFilterIds.needsReview) {
    if (value === 'MORE_TIME_REQUESTED') {
      return 'More time requested';
    }
    return 'Review';
  }

  return String(value);
};
